import styled from 'styled-components'

const Section = styled.section`
    border-radius: 20px;
    box-shadow: 0px 2px 10px 2px rgba(110, 110, 110, 0.06);
    display: flex;
    padding: 33px 0;
    margin-bottom: 30px;
    background-color: var(--color-white);
`

const LeftColumn = styled.div`
    width: 420px;
    padding: 0 30px;
`

const RightColumn = styled.div`
    flex: 1 1 0%;
    min-width: 0;
    width: 100%;
    max-width: 955px;
    padding: 0 20px;
`
const Divider = styled.div`
    width: 1px;
    height: 596px;
    background-color: var(--color-title);
`

// Filters row and wrappers to match TotalUsers layout
const FiltersRow = styled.div`
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`

const TypeSelectWrap = styled.div`
  min-width: 180px;
  flex: 1 1 180px;
  max-width: 250px;
`

const StatusSelectWrap = styled.div`
  min-width: 140px;
  flex: 1 1 140px;
  max-width: 200px;
`

const SentimentSelectWrap = styled.div`
  min-width: 160px;
  flex: 1 1 160px;
  max-width: 220px;
`

const Spacer = styled.div`
  flex: 1 1 auto;
`

// Simple segmented toggle
const ViewToggle = styled.div`
  display: inline-flex;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--color-input-stroke);
  height: 45px;
`

const ToggleButton = styled.button<{ active?: boolean }>`
  appearance: none;
  border: none;
  padding: 15px 40px;
  background: ${({ active }) => (active ? 'var(--color-button-primary)' : 'white')};
  color: ${({ active }) => (active ? 'white' : '#2e2e32')};
  font-weight: 500;
  cursor: pointer;
  font-size: 14px;
  min-width: 149px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 21px;
  transition: background 0.2s ease, color 0.2s ease;
  border: ${({ active }) => (active ? '1px solid var(--color-button-primary)' : '1px solid rgba(244, 244, 246, 1)')};
  &:first-child { border-right: 1px solid rgba(244, 244, 246, 1); }
`

interface SpacingProps {
  mt?: number
}

const PaginationSpacer = styled.div<SpacingProps>`
  margin-top: ${({ mt = 14 }) => mt}px;
`

export { Section, LeftColumn, RightColumn, Divider, FiltersRow, TypeSelectWrap, StatusSelectWrap, SentimentSelectWrap, Spacer, ViewToggle, ToggleButton, PaginationSpacer }

// Pie chart styles
export const PieTitle = styled.h3`
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  color: var(--color-text-black);
  margin: 0 0 0px 0;
`

export const PieChartWrap = styled.div`
  margin-top: 50px;
`

export const PieLegend = styled.div`
  margin-top: 0px;
`

export const PieLegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`

export const PieColorSwatch = styled.span<{ bg: string }>`
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  background-color: ${({ bg }) => bg};
  margin-right: 10px;
`

export const PieLegendLabel = styled.span`
  flex: 1 1 auto;
  color: rgba(28, 28, 30, 1);;
  font-size: 16px;
  line-height: 20px;
`

export const PieLegendValue = styled.span`
  color: var(--color-subtitle);
`

// Bar chart styles
export const BarTitle = styled(PieTitle)`

`

export const BarChartWrap = styled.div`
min-height: 575px;
  /* height handled via chart props; wrapper left for spacing if needed */
  
  /* Custom legend styling */
  .chartjs-legend {
    margin-top: 40px !important;
    padding-top: 20px !important;
  }
  
  .chartjs-legend ul {
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;
    display: flex !important;
    justify-content: center !important;
    gap: 30px !important;
  }
  
  .chartjs-legend li {
    display: flex !important;
    align-items: center !important;
    margin: 0 !important;
  }
  
  .chartjs-legend li span {
    display: inline-block !important;
    width: 16px !important;
    height: 16px !important;
    border-radius: 4px !important;
    margin-right: 10px !important;
    border: 1px solid rgba(0,0,0,0.1) !important;
  }
`

export const BarLegend = styled.div`
display:flex;
align-items:center;
margin-top:40px;
justify-content:center;
gap:30px;
`

export const BarLegendItem = styled.div`
display:flex;
align-items:center;
`
export const BarLegendLabel = styled.span`
color: rgba(28, 28, 30, 1);
font-size: 16px;
line-height: 16px;
font-weight: 400;
`
